import {Box, Grid, FormControl, Typography, Stack } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DeleteImage from '../../../assets/delete-img-modal.svg';
import '../../DataPipeline/dataPipeline.scss';
import { useState, useEffect } from 'react';
import {
	addResourceMappingProgram,
	addResourceMappingProject,
	deleteProgram,
	deleteProjectDetails,
	editProgramDetails,
	editProjectDetails,
	getProgramDetailsById,
} from '../../../service/service';
import { useNavigate } from 'react-router-dom';
import CustomTextField from 'components/Inputs/CustomTextField';
import { useTheme } from "@mui/material/styles";

export function ResourceMappingModal({ handleEditClose, programData, passInfoToParent, errorMessage, setErrorMessage }: any) {
	const theme= useTheme();
	const colors = theme.palette;
	const [loading, ] = useState<any>({
		project: false
	});
	const [saveBtnLoader, setSaveBtnLoader] = useState(false);
	const [, setIsDisabled] = useState<any>({
		description: false,
		owner: false
	});
	const navigate = useNavigate();
	const [inputValue, ] = useState('');
	const [projectList, ] = useState([]);
	
	const [formData, setFormData] = useState<any>({
		id: '',
		programName: '',
		programDescription: '',
		programOwner: '',
		projectName: null,
		projectDescription: '',
		projectOwner: '',
		clarityId: ''
	});
	const [, setFormErrors] = useState({
		estimatedDurationError: ''
	});

	const commonInputSx = {
		"& .MuiInputBase-input": {
			color: `${colors.input.text} !important`,
		},
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: `${colors.input.border} !important`,
		},
		"& .MuiInputLabel-root": {
			color: `${colors.input.text} !important`,
		},
		"& .MuiInputLabel-root.Mui-focused": {
			color: `${colors.input.text} !important`,
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: `${colors.input.borderFocus} !important`,
		},
		"& .MuiFormHelperText-root": {
			color: `${colors.input.text} !important`,
		},
	};

	const getProjectDetails = () => {
		setFormData({
			projectName: programData.data.projectName,
			projectDescription: programData.data.projectDescription,
			projectOwner: programData.data.projectOwner,
			projectId: programData.data.projectId,
			...(programData.action === 'DELETE' && {programId: programData.data.programId})
		});
	};

	const getProgramDetails = async () => {
		let result = await getProgramDetailsById(programData.data.programId);
		programData.data = result.data;
		setFormData({
			id: programData.data.programId,
			programName: result.data.programName,
			programDescription: result.data.programDescription,
			programOwner: result.data.programOwner
		});
	};

	const editProgram = async () => {
		let data = {
			id: formData.id,
			programName: formData.programName,
			programDescription: formData.programDescription,
			programOwner: formData.programOwner
		};
		const result=await editProgramDetails(data);
		validateResponse(result);
	};

	const editProject = async () => {
		let data = {
			id: formData.projectId,
			projectOwner:  formData.projectOwner,
			projectName: formData.projectName,
			projectDescription: formData.projectDescription,
		};
		const result =await editProjectDetails(data);
		validateResponse(result);
	};

	const validateResponse = (result: any) => {
		if (result.success) {
			if (result.success) {
				
				return {success: true, data: result.data};
			} else {
				setErrorMessage(result?.data?.message);
				return {success: false, data: result.data};
			}
		} else if (result.response.data) {
			const { success } = result.response.data;
			const { message } = result.response.data?.data;

			if (success) {
				
				return {success: true, data: result.response.data};
			} else {
				setErrorMessage(message);
				return {success: false, data: result.response.data};
			}
		}
	}

	const addProgram = async (data: any) => {
		const result = await addResourceMappingProgram(data);
		validateResponse(result);
		setSaveBtnLoader(false);
	};

	const addProject = async (data: any) => {
		let result = await addResourceMappingProject(data);
		validateResponse(result);
		setSaveBtnLoader(false);
		return result;
	};

	const handlePostSubmitNavigation = () => {
		if (programData['from'] === 'view' && programData.type === 'Program') 
			navigate('/finops/resourcemapping/programs');
		else if (programData['from'] === 'delete' && programData.type === 'Project') {
			navigate(
				`/finops/resourcemapping/programs/${window.location.pathname.split('/')[4]}/${window.location.pathname
					.split('/')[6]
					.replace(/%20/g, ' ')}`
			);
		}
	};

	const handleDelete = async () => {
		if (programData.type === 'Program') {
			await deleteProgram(programData.data.programId);
			return;
		}

		if (programData.type === 'Project') {
			await deleteProjectDetails(formData);
		}
	};

	const handleEdit = async () => {
		if (programData.type === 'Program') {
			await editProgram();
			return;
		}

		if (inputValue) {
			formData['projectName'] = inputValue;
		}
		await editProject();
	};

	const handleAdd = async () => {
		if (programData.type === 'Program') {
			await addProgram(formData);
			return;
		}

		const formPayload = {
			programId: window.location.pathname.split('/')[4].replace(/%20/g, ' '),
			projectName: formData?.projectName?.label || formData?.projectName,
			clarityProId: formData?.clarityId || '',
			projectDescription: formData?.projectDescription,
			projectOwner: formData?.projectOwner ? formData?.projectOwner : '',
			is_new_project: true
		};
		await addProject(formPayload);
	};

	const handleSubmitAction = async () => {
		if (programData.action === 'ADD') {
			return handleAdd();
		}
		if (programData.action === 'EDIT') {
			return handleEdit();
		}
		if (programData.action === 'DELETE') {
			return handleDelete();
		}
	};

	const onSubmit = async (event: any) => {
		if (saveBtnLoader) return;
		setSaveBtnLoader(true);
		event.preventDefault();
		try {
			await handleSubmitAction();
		} finally {
			setSaveBtnLoader(false);
			handleEditClose(false);
			handlePostSubmitNavigation();
		}
	};

	const isFormValid = () => {
		return formData.programName && formData.programName.length <= 100 && formData.programOwner;
	};

	const isProjectFormValid = () => {
		return (
			formData.projectName && formData.projectName.length <= 100 
			&& formData.projectDescription && formData.projectOwner
		);
	};

	const handleEventChange = (event: any) => {
		const eventVal = event && event?.target;
		let name;
		let value = '';
		if (eventVal) {
			name = eventVal.name;
			value = eventVal.type === 'checkbox'
				? eventVal.checked
				: eventVal.value;
		}
		setFormData({
			...formData,
			[name]: value
		});
	};

	const handleProjectNameOnChange = (newInput: any) => {
		setIsDisabled({
			description: false,
			owner: false
		});

		if (!newInput?.id) return;

		let data: any = projectList.filter((obj: any) => obj.Project_Code === newInput.id);
		if (!data) return;
		setFormData({
			...formData,
			projectDescription: data[0].Project_Description || '',
			projectOwner: data[0].EMPLOYEE_NAME,
			projectName: data[0].Project_Name,
			clarityId: data[0].Project_Code
		});
		setIsDisabled({
			description: true,
			owner: true
		});
	};

	const handleTypedChange = (type: string, newValue: any) => {
		if (type === 'projectOwner') {
			setFormData({
				...formData,
				projectOwner: ''
			});
		} else if (type === 'projectDescription') {
			setFormData({
				...formData,
				projectDescription: ''
			});
		}

		if (type === 'projectName') {
			handleProjectNameOnChange(newValue);
		} else if (type === 'projectOwner') {
			setFormData({
				...formData,
				[type]: newValue
			});
		}
	};

	const handleChange = (event: any, newValue: any = '', type: string = '') => {
		if (type) {
			handleTypedChange(type, newValue);
		} else {
			handleEventChange(event);
		}

		setFormErrors({ estimatedDurationError: '' });
	};

	const handleClose = () => {
		handleEditClose(true);
	};

	const getAddTitle = () => {
		return programData.type === 'Program'
			? `Create ${programData.type}`
			: 'Create Project';
	};

	const getEditTitle = () => {
		const name =
			programData.type === 'Program'
				? programData.data?.programName
				: programData.data?.projectName;

		return `Edit ${programData.type}: ${name}`;
	};

	const getDeleteTitle = () => {
		if (programData.type === 'Program') {
			return `Deleting ${programData.data?.programName}`;
		}

		if (programData.type === 'Project') {
			return `Deleting ${programData.data?.projectName}`;
		}

		return 'Deleting';
	};

	const getTitle = () => {
		switch (programData.action) {
			case 'DELETE':
				return getDeleteTitle();

			case 'EDIT':
				return getEditTitle();

			default:
				return getAddTitle();
		}
	};

	useEffect(() => {
		if (programData.type === 'Program') {
			if (programData.action === 'EDIT' || programData.action === 'DELETE') {
				getProgramDetails();
			}
		} else if (programData.type === 'Project') {
			if (programData.action === 'EDIT' || programData.action === 'DELETE') {
				getProjectDetails();
			}
		}
	}, []);

	let deleteMessageContent: any = null;
	if (programData.type === 'Program') {
		deleteMessageContent = `this ${programData.type}`;
	} else if (programData.type === 'Project') {
		deleteMessageContent = (
			<Box component="span">
				this project from{' '}
				<Box component="span" sx={{ fontWeight: '800' }}>
					{programData?.data?.programName}
				</Box>
				?
			</Box>
		);
	}

	const renderDeleteContent = () => (
		<Box p={2} bgcolor={`${colors.modal.bg} !important`} color={`${colors.modal.text} !important`}>
			<DialogContent>
				<Stack direction="row" spacing={2}>
					<Box component="img" src={DeleteImage} alt="" />
					<Stack spacing={2}>
						<Typography fontSize="28px" fontWeight={600}>
							Are you sure to delete{' '}
							{deleteMessageContent}
						</Typography>
						<Typography variant="body1">Once confirmed, the action can't be undone.</Typography>
					</Stack>
				</Stack>
			</DialogContent>

			<DialogActions>
				<Button onClick={handleClose} variant="pepwiseOutline" sx={{ color: `${colors.buttons.primary.color} !important` }}>
					NO
				</Button>
				<Button onClick={onSubmit} variant="pepwiseError">
					{saveBtnLoader ? 'Deleting...' : 'Delete'}
				</Button>
			</DialogActions>
		</Box>
	);

	const btnLabel = programData.action === 'EDIT' ? 'UPDATE & SAVE' : 'SAVE';
	const renderProjectForm = () => (
		<Box component="form" onSubmit={onSubmit} noValidate p={2} bgcolor={`${colors.modal.bg} !important`} color={`${colors.modal.text} !important`}>
			<DialogContent>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<CustomTextField
							id="projectName"
							label={
								<Box display="flex" alignItems="center">
									Project Name*
									<Typography variant="body2" fontSize="0.75rem" sx={{ marginLeft: 1 }}>
										(Max 100 characters)
									</Typography>
								</Box>
							}
							name="projectName"
							variant="outlined"
							autoComplete="off"
							value={formData.projectName}
							error={formData.projectName?.length > 500}
							inputProps={{ maxLength: 500 }}
							helperText="Project name can't contain more that 500 characters."
							onChange={handleChange}
							sx={commonInputSx}
						/>
					</Grid>

					<Grid item xs={6}>
						<FormControl fullWidth>
							<CustomTextField
								id="projectDescription"
								label="Project Description"
								name="projectDescription"
								variant="outlined"
								autoComplete="off"
								value={formData.projectDescription}
								inputProps={{ maxLength: 4000 }}
								required
								onChange={handleChange}
								sx={commonInputSx}
							/>
						</FormControl>
					</Grid>
					<Grid item xs={6}>
						<FormControl fullWidth>
							<CustomTextField
								id="projectOwner"
								label={
									<Box>
										Project Owner*
										<Box component="span" fontSize="0.75rem" sx={{ fontStyle: 'italic' }}>
											{' '}
											(@Name/GPID/Email)
										</Box>
									</Box>
								}
								name="projectOwner"
								variant="outlined"
								autoComplete="off"
								value={formData.projectOwner}
								inputProps={{ maxLength: 500 }}
								onChange={handleChange}
								sx={commonInputSx}
							/>
						</FormControl>
					</Grid>
				</Grid>
			</DialogContent>

			<DialogActions>
				<Button onClick={handleClose} variant="pepwiseOutline" sx={{ color: `${colors.buttons.primary.color} !important` }}>
					CANCEL
				</Button>
				<Button disabled={!isProjectFormValid()} type="submit" variant="pepwiseSecondary">
					{saveBtnLoader ? 'SAVING...' : btnLabel}
				</Button>
			</DialogActions>
		</Box>
	);

	const renderProgramForm = () => (
		<Box component="form" onSubmit={onSubmit} noValidate p={2} bgcolor={`${colors.modal.bg} !important`} color={`${colors.modal.text} !important`}>
			<DialogContent>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<CustomTextField
							error={formData.programName?.length > 500}
							label="Program Name *"
							id="programName"
							name="programName"
							variant="outlined"
							autoComplete="off"
							value={formData.programName}
							onChange={handleChange}
							fullWidth
							inputProps={{ maxLength: 500 }}
							helperText="Program name can't contain more than 500 characters."
							sx={commonInputSx}
						/>
					</Grid>
					<Grid item xs={6}>
						<FormControl fullWidth>
							<CustomTextField
								id="programDescription"
								label="Program Description"
								name="programDescription"
								variant="outlined"
								autoComplete="off"
								value={formData.programDescription}
								onChange={handleChange}
								inputProps={{ maxLength: 1000 }}
								sx={commonInputSx}
							/>
						</FormControl>
					</Grid>
					<Grid item xs={6}>
						<FormControl fullWidth>
							<CustomTextField
								id="programOwner"
								label={
									<Box>
										Program Owner*
										<Box component="span" fontSize="0.75rem" sx={{ fontStyle: 'italic' }}>
											{' '}
											(@Name/GPID/Email)
										</Box>
									</Box>
								}
								name="programOwner"
								variant="outlined"
								autoComplete="off"
								value={formData.programOwner}
								onChange={handleChange}
								inputProps={{ maxLength: 200 }}
								sx={commonInputSx}
							/>
						</FormControl>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} variant="pepwiseOutline" sx={{ color: `${colors.buttons.primary.color} !important`,px:3,py:1.2 }}>
					CANCEL
				</Button>
				<Button disabled={!isFormValid()} type="submit" variant="pepwiseSecondary" sx={{px:6,py:1.2}}>
					{saveBtnLoader ? 'SAVING...' : btnLabel}
				</Button>
			</DialogActions>
		</Box>
	);

	const getContent = () => {
		switch (programData.action) {
			case 'EDIT':
			case 'ADD':
				return programData.type === 'Program'
					? renderProgramForm()
					: renderProjectForm();

			case 'DELETE':
				return renderDeleteContent();

			default:
				return null;
		}
	};

	return (
		<>
			<DialogTitle bgcolor="primary.main" sx={{ p: '8px 16px !important' }}>
				<Box display="flex" alignItems="center">
					<Typography variant="widgetTitle" flexGrow={1}>
						{getTitle()}
					</Typography>
					<Box>
						<IconButton onClick={handleClose} sx={{ color: 'white.main' }}>
							<CloseIcon />
						</IconButton>
					</Box>
				</Box>
			</DialogTitle>

			{!loading.project ? (
				getContent()
			) : (
				<Box sx={{ padding: '40px 20px', textAlign: 'center', fontSize: '14px', backgroundColor: '#0c0f25' }}>
					Fetching Data...
				</Box>
			)}
		</>
	);
}
